import { useMatches} from "@remix-run/react";
import { useEffect, useState } from 'react'

type TEventData = {
  eventName: string
  payload: {
    transaction_id?: string;
    send_to?: string,
    value?: string,
    currency?: 'PLN'
  }
}

type TGTagEventFunction<
  TLoaderData = unknown
> = ( data: TLoaderData ) => TEventData[];

export type HandleGTagEvent<
  TLoaderData = unknown,
> = {
  gTagEvent: TGTagEventFunction<TLoaderData>;
};

const objectToString = (obj: TEventData['payload']) => {
    return Object.entries(obj).map(entry => {
    return `'${entry[0]}':'${entry[1]}'`
  }).join(',')
}


function isHandleGTagEvent(
  handle: unknown
): handle is HandleGTagEvent {
  return (
    handle !== undefined &&
    (handle as HandleGTagEvent).gTagEvent !== undefined &&
    typeof (handle as HandleGTagEvent).gTagEvent === "function"
  );
}

const getRenderedScript = (tagEvents: TEventData[]): string => {
  return tagEvents.reduce((acc, eventData) => {
    return acc + ' ' +  
      `window.gtag && gtag('event', '${eventData.eventName}', {${objectToString(eventData.payload)}})`
  }, '')
}

let isHydrating = true

export function GTagEvent() {
  const [isHydrated, setIsHydrated] = useState(!isHydrating);
  const matches = useMatches();
  const tagEvents = matches.flatMap((match) => {
    const { handle, data } = match;

    if (isHandleGTagEvent(handle)) {
      const result = handle.gTagEvent(data);

      if (result) {
        return result;
      }
    }

    return [];
  });
  
  useEffect(() => {
    isHydrating = false
    setIsHydrated(true)
  }, [])

  useEffect(() => {
    if (isHydrated) {
      tagEvents.forEach((eventData) => {
        if (window.gtag) {
          window.gtag('event', eventData.eventName, eventData.payload)
        }
      })

    }
  }, [matches])

  if (tagEvents.length === 0) {
    return <script />
  }

  return (
    <script
      id="gTagEvent"
      type="text/plain"
      data-category="analytics"
      data-service="ga" 
      dangerouslySetInnerHTML={{
        __html: getRenderedScript(tagEvents),
      }}
    ></script>
  );
}

export function GTagEventOnClick (tagEvents: TEventData[]) {
  tagEvents.forEach((eventData) => {
    if (window.gtag) {
      window.gtag('event', eventData.eventName, eventData.payload)
    }
  })
}